import { setupLogger } from '../lib/PST.Web.Common/src/services/logger/log';
import { initXHR } from './api/xhr/init';

const setup = (store) => {
    initXHR(store);
    setupLogger();
};

export { setup };
